import styled from 'styled-components';

type TableContainerProps = {
    scaleFactor: number;
};

export const TableContainer = styled.div<TableContainerProps>`
    font-size: ${props => props.scaleFactor * 16}px;
    width: 100%;
    margin: 0 auto 70px auto;

    table {
        border-collapse: collapse;
        width: 100%;
        font-family: var(--font-circular);
    }

    td, th {
        padding: 0.6em 1.5em;
        text-align: center;
        border-right: 1px solid rgb(232, 198, 142);
        border-bottom: 1px solid rgb(232, 198, 142);
        color: rgb(250, 235, 184);

        &:last-child {
            border-right: none;
        }
    }

    tr:last-child td,
    tr:last-child th {
        border-bottom: none;
    }

    tr:nth-child(odd):not(:first-child) {
        background: rgba(0, 0, 0, 0.3);
    }

    th.rowLabel {
        font-weight: 100;
        font-size: 0.85em;
        text-align: center;
        vertical-align: middle;
        padding: 0.6em 1.5em;
        background: rgba(250, 235, 184, 0.08);
        color: rgba(250, 235, 184, 0.7);
    }

    th.emptyHeader {
        background: rgba(250, 235, 184, 0.08);
    }

    .placeRow {
        th {
            background: rgba(250, 235, 184, 0.08);
            border-bottom: 2px solid rgb(232, 198, 142);
        }
    }

    .placeCell {
        font-size: 1.5em;
        font-weight: 100;
        color: rgba(250, 235, 184, 0.7);

        sup {
            font-size: 0.6em;
            vertical-align: super;
        }
    }

    .nameRow td {
        color: rgb(225, 212, 166);
    }

    .nameCell {
        font-size: 1.75em;
        font-weight: 600;
    }

    .bankCell {
        font-size: 1em;
        font-weight: 300;
    }

    .wagerCell {
        font-size: 1.5em;
        font-weight: 700;
        min-height: 2em;
    }

    .answerCell {
        font-size: 1.5em;
        font-weight: 500;

        &.wrong {
            color: #ff6b6b;
        }

        &.correct {
            color: #51cf66;
        }
    }
`;
